import * as React from 'react';
import { currentPrimaryDimensionIndexContext } from './context';
export var CurrentPrimaryDimensionIndexProvider = function (props) {
    var index = props.index, children = props.children;
    return (React.createElement(currentPrimaryDimensionIndexContext.Provider, { value: index }, children));
};
